import React, { useMemo } from 'react'

import { environment } from '../../../../core/components'
import { useQueryParams } from '../../../../core/router'
import type { ProductSkuOfferDeliveryChannel } from '../../../../__generated__/schema-types'
import { PriceInfo } from './PriceInfo'

type OfferCache =
  | {
      deliveryChannel: string
      priority: number
      listPrice: {
        __ref: string
      }
      netPrice: {
        __ref: string
      }
      seller: {
        __ref: string
      }
    }
  | undefined

type ListPriceCache =
  | {
      amount: number
    }
  | undefined

type NetPriceCache =
  | {
      amount: number
    }
  | undefined

type SellerCache =
  | {
      id: string
    }
  | undefined

export const ProductSkuPriceLoading = () => {
  const offerId = useQueryParams().get('offerId') ?? '' // TODO: create PDP query params constant to use here and search/explore

  const [bestOffer] = useMemo(() => {
    const store = environment.getStore().getSource()
    const offerCache = store.get(offerId) as OfferCache

    const listPrice = store.get(
      offerCache?.listPrice?.__ref ?? ''
    ) as ListPriceCache

    const netPrice = store.get(
      offerCache?.netPrice?.__ref ?? ''
    ) as NetPriceCache

    const seller = store.get(offerCache?.seller?.__ref ?? '') as SellerCache

    if (!offerCache || !listPrice?.amount || !netPrice?.amount || !seller?.id) {
      return []
    }

    return [
      {
        deliveryChannel: offerCache.deliveryChannel as ProductSkuOfferDeliveryChannel,
        priority: offerCache.priority,
        listPrice: {
          amount: listPrice.amount,
        },
        netPrice: {
          amount: netPrice.amount,
        },
        sellerId: seller.id,
      },
    ]
  }, [offerId])

  return <PriceInfo offer={bestOffer} />
}
